import { render, staticRenderFns } from "./CommonRadioGroup.vue?vue&type=template&id=5dcda284&scoped=true"
import script from "./CommonRadioGroup.vue?vue&type=script&lang=js"
export * from "./CommonRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcda284",
  null
  
)

export default component.exports